/**
 * Filter Drawer Height Calculator
 * Dynamically calculates available height by measuring actual header and footer
 */

class FilterDrawerHeight {
  constructor() {
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    const drawer = document.querySelector('.facets--drawer');
    if (!drawer) return;

    const header = drawer.querySelector('.filter-drawer__header');
    const footer = drawer.querySelector('.filter-drawer__footer');
    const bodyInner = drawer.querySelector('.filter-drawer__body-inner');
    
    if (!header || !footer || !bodyInner) return;

    const calculateHeight = () => {
      const headerHeight = header.offsetHeight;
      const footerHeight = footer.offsetHeight;
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      
      bodyInner.style.maxHeight = `${availableHeight}px`;
    };

    // Calculate when drawer opens
    const observer = new MutationObserver(() => {
      if (drawer.open) {
        setTimeout(calculateHeight, 50);
      }
    });
    
    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['open']
    });
    
    // Recalculate on resize
    window.addEventListener('resize', () => {
      if (drawer.open) {
        calculateHeight();
      }
    });
  }
}

new FilterDrawerHeight();

